// extracted by mini-css-extract-plugin
export var BrandFooter = "index-module--BrandFooter--91c64";
export var Copyright = "index-module--Copyright--14c7e";
export var PoweredBy = "index-module--PoweredBy--4a617";
export var RTL = "index-module--RTL--e410b";
export var TOS = "index-module--TOS--44bf3";